import { createBrowserHistory } from 'history';

const instance = createBrowserHistory();

export const navigateTo = (path, params) => instance.push(path, params);

export default instance;
